import { Routes } from '@angular/router';
import { ApplicationDetailComponent } from './components/application-detail/application-detail.component';
import { ApplicationsComponent } from './components/applications/applications.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { HomeComponent } from './components/home/home.component';
import { ProvidersComponent } from './components/providers/providers.component';
import { RegisterComponent } from './components/register/register.component';
import { ReportsComponent } from './components/reports/reports.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ShellComponent } from './components/shell/shell.component';
import { authGuard } from './guards/auth.guard';
import { canActivateAuthRole } from './guards/keycloak.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', component: HomeComponent },
  { path: 'register', component: RegisterComponent },
  {
    // Authenticated area: every child renders inside the sidebar + top bar shell.
    path: '',
    component: ShellComponent,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'providers', component: ProvidersComponent },
      { path: 'applications', component: ApplicationsComponent },
      { path: 'applications/:appId', component: ApplicationDetailComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'settings', component: SettingsComponent },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
